/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgramsSplitReduceFn = exports.getIsProgramWithinTime = exports.createTvListingsProvider = void 0;
var _times2 = _interopRequireDefault(require("lodash/times"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var programLengths = [30, 45, 60, 90, 120];
var getRandomProgramLength = function getRandomProgramLength() {
  var index = Math.floor(Math.random() * programLengths.length);
  return programLengths[index];
};
var createProgram = function createProgram(startTime, endTime, channelIndex, programNumber) {
  return {
    id: "channel_".concat(channelIndex, "_program_").concat(startTime, "_").concat(programNumber),
    type: 'movie',
    title: "Program ".concat(programNumber),
    description: 'A description about this program',
    startTime: startTime,
    endTime: endTime
  };
};
var createProgramList = function createProgramList(_ref) {
  var startTime = _ref.startTime,
    endTime = _ref.endTime,
    channelIndex = _ref.channelIndex,
    programOpts = _ref.programOpts;
  var timePosition = startTime;
  var programs = [];
  var count = 0;
  while (timePosition < endTime) {
    count += 1;
    var programLength = (channelIndex === 0 || programOpts.fixedProgramLength ? 60 : getRandomProgramLength()) * 60 * 1000;
    var programEndTime = timePosition + programLength;
    var program = createProgram(timePosition, programEndTime, channelIndex, count);
    programs.push(program);
    timePosition = programEndTime;
  }
  return programs;
};
var createChannel = function createChannel(_ref2) {
  var channelIndex = _ref2.channelIndex,
    startTime = _ref2.startTime,
    endTime = _ref2.endTime,
    programOpts = _ref2.programOpts;
  return {
    channelId: "Channel ".concat(channelIndex + 1),
    programs: createProgramList({
      startTime: startTime,
      endTime: endTime,
      channelIndex: channelIndex,
      programOpts: programOpts
    })
  };
};
var createChannelList = function createChannelList(_ref3) {
  var startTime = _ref3.startTime,
    endTime = _ref3.endTime,
    nrOfChannels = _ref3.nrOfChannels,
    programOpts = _ref3.programOpts;
  return (0, _times2["default"])(nrOfChannels, function (channelIndex) {
    return createChannel({
      channelIndex: channelIndex,
      startTime: startTime,
      endTime: endTime,
      programOpts: programOpts
    });
  });
};
var getIsProgramWithinTime = function getIsProgramWithinTime(startTime, endTime, includeOverlapping, program) {
  return program.startTime < endTime && program.endTime > startTime && (includeOverlapping || program.endTime <= endTime);
};
exports.getIsProgramWithinTime = getIsProgramWithinTime;
var getProgramsWithinTime = function getProgramsWithinTime(startTime, endTime, includeOverlapping, programs) {
  return programs.filter(getIsProgramWithinTime.bind(null, startTime, endTime, includeOverlapping));
};
var createTvListingsProvider = function createTvListingsProvider(minTime, maxTime, nrOfChannels, includeOverlappingPrograms) {
  var programOpts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var channelList = createChannelList({
    startTime: minTime,
    endTime: maxTime,
    nrOfChannels: nrOfChannels,
    programOpts: programOpts
  });
  return function (startTime, endTime, offset, count) {
    return {
      entries: channelList.slice(offset, offset + count).map(function (channel) {
        return _objectSpread(_objectSpread({}, channel), {}, {
          programs: getProgramsWithinTime(startTime, endTime, includeOverlappingPrograms, channel.programs)
        });
      }),
      totalCount: nrOfChannels,
      pageSize: 20,
      pageNumber: 1
    };
  };
};
exports.createTvListingsProvider = createTvListingsProvider;
var getProgramsSplitReduceFn = function getProgramsSplitReduceFn(_ref4) {
  var displayTimespan = _ref4.displayTimespan,
    epgStartTime = _ref4.epgStartTime,
    parameters = _ref4.parameters;
  return function (acc, program) {
    var xCoordinateOfStart = Math.floor((program.startTime - epgStartTime) / displayTimespan);
    var xCoordinateOfEnd = Math.floor((program.endTime - epgStartTime - 1) / displayTimespan);
    var newPrograms = [];
    if (xCoordinateOfStart !== xCoordinateOfEnd) {
      var diff = xCoordinateOfEnd - xCoordinateOfStart;
      (0, _times2["default"])(1 + xCoordinateOfEnd - xCoordinateOfStart, function (i) {
        var startTime = i === 0 ? program.startTime : displayTimespan * (i + xCoordinateOfStart) + epgStartTime;
        var endTime = i === diff ? program.endTime : displayTimespan * (i + xCoordinateOfStart + 1) + epgStartTime;
        if (startTime === endTime || endTime <= epgStartTime || endTime <= parameters.startTime || startTime >= parameters.endTime) {
          return;
        }
        newPrograms.push(_objectSpread(_objectSpread({}, program), {}, {
          id: "".concat(program.id, ">>").concat(i),
          realStartTime: program.startTime,
          realEndTime: program.endTime,
          startTime: startTime,
          endTime: endTime
        }));
      });
    } else {
      newPrograms.push(program);
    }
    return acc.concat(newPrograms);
  };
};
exports.getProgramsSplitReduceFn = getProgramsSplitReduceFn;